import {Component, Input} from '@angular/core';
import {ApplicationSettings} from '../../../domain/contact-settings';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'app-qr-code-description',
  templateUrl: './qr-code-description.component.html',
  styleUrls: ['./qr-code-description.component.scss'],
  imports: [IonicModule, TranslateModule]
})
export class QrCodeDescriptionComponent {
  @Input() applicationSettings: ApplicationSettings;
}
